import "./Celebration.css";
import React, { useRef } from "react";
export default function Celebration({ highScore, elapsedTime }) {
    const highScoreRef = useRef(null);
    function formatTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        
        return minutes > 0 
          ? `${minutes}m ${remainingSeconds}s` 
          : `${seconds}s`;
      }
    return (
            <div className="celebration-container">
                <div className="celebration-notification">
                    <h3>Obrigado por participar</h3>
                    { <p>Você terminou o jogo em: <span>{formatTime(elapsedTime)}</span></p>}
                    <p><small className="font-sm">Jogue quantas vezes quiser!</small></p>
                </div>
            </div>
        );
}
